// <i18n-ignore
export default {
    // baseUrl:'http://61.184.190.242:29081/api',
    // baseUrl:'/api',
    // baseUrl:'https://mall.bbc.shkhxxkj.com/api',
    baseUrl: '/api',
    // baseUrl:process.env.NODE_ENV =='development'  ? 'http://121.36.6.48:9081/api' : '/api',
    login: '/auth/login',
    getSeo: '/bbb/seo',
    theme: '/bbb/home/themePage',
    matchMore: '/bbb/goodsInfo/listGoodsForBom',
    importTemplate: '/bbb/goodsInfo/match/analyzeExcel',
    getCheckCode: '/pc/bbbAuth/getCheckCode',
    register: '/pc/bbbAuth/register',
    paypalPay_doPay: '/bbb/userCenter/tradePay/pc/paypalPay/doPay',
    couponsApply: '/bbb/userCenter/coupons/receive',
    coupons: '/bbb/marketActivity/coupons',
    getApplicationScenario: '/bbb/getApplicationScenario',
    goodsPlanDeataiId: '/bbb/goodsPlan/detail/{id}',
    goodsPlanList: '/bbb/goodsPlan/pageList',
    goodsAppli: '/bbb/goodsAppli/list',
    searchSku: '/bbb/goodsInfo/searchSku',
    inquiryOrderAdd: '/bbb/inquiryOrder/add',
    getQrcodeLOginInfo: '/wx/open/getPcQrcodeParam',
    getPhoneCheck: '/pc/bbbAuth/getPhoneCheck/{phone}',
    publicConfig: '/bbb/home/getSiteOption', //客户入驻协议
    getsiteService: '/bbb/siteService', //平台电话和qq
    getCorpName: '/bbb/userCenter/apply/getCorpName', //平台电话和qq
    dingzhi: '/bbb/inquiryOrder/add', //平台电话和qq
    getTradeId: '/bbb/userCenter/tradeInvoice/detail/{id}', //平台电话和qq
    kaiye: '/bbb/businessConsulting/add', //平台电话和qq
    buycenterData: '/bbb/userCenter/buyInfo',
    usercenterData: '/bbb/userCenter/userAccountInfo',
    serviceQQindex: '/bbb/merchService/listPhone', //获取商城首页客服QQ号码
    serviceQQ: '/bbb/shopHome/service/{shopId}', //获取商店客服QQ号码
    brandList: '/bbb/goodsCategory/listGroupBrand', //品牌列表
    brandDetail: '/bbb/goodsCategory/brand/{id}', //品牌详情
    picturesUpload: '/merchadmin/pictures/upload', //本地图片上传-tmy
    applyFlow: '/merchadmin/merchantApply/applyFlow', //商家入驻流程提交-tmy
    legalQuery: '/merchadmin/merchantApply/legalQuery/', //商家入驻流程企业查询-tmy
    corpTypeList: '/merchadmin/merchantApply/corpTypeList', //商家入驻（企业类型选择列表）-tmy
    corpTypeCertList: '/merchadmin/merchantApply/corpTypeCertList/', //商家入驻企业类型证照列表（企业类型ID）-tmy
    applyFlowQuery: '/merchadmin/merchantApply/applyFlowQuery', //商家入驻流程查询(分段)-tmy
    listBrandVO: '/merchant/pc/goodsBrand/listBrandVO', //查询品牌信息列表-tmy
    listLevel1Categories: '/merchant/pc/goodsCategory/listLevel1Categories', //查询商品一级分类-tmy
    merchantSiteNavigation: '/bbb/merchantSiteNavigation', //商家入驻底部链接-tmy
    quoteOrder: '/bbb/userCenter/quotePriceOrder/fromQuotePriceOrder/{id}', //商家入驻底部链接-tmy
    categoryTree: '/bbb/goodsCategory/categoryTree', //2Bpc端首页分类菜单信息-cl
    bbbGoodsCategoryGetGoodsRecommendVO: '/bbb/home/getGoodsRecommendVO', //2Bpc端首页推荐商品信息-cl
    bbbSubmitComment: '/bbb/tradeComment/orderCommentByOrder',
    bbbGoodsCategoryGetCategoryNavigationVO: '/bbb/goodsCategory/getCategoryNavigationVO', //分类导航搜索管理-cl
    goodsRecommend: '/bbb/goodsInfo/detail/recommend', //商品的猜你喜欢
    brandDetail: '/bbb/goodsBrand/brand/{id}', //商品的品牌详情
    bbbGoodsInfo: '/bbb/goodsInfo/detail/{id}', //商品详情
    bbbGoodsList: '/bbb/goodsInfo/pageList', //商品列表-cl
    bbbGoodsInfoSearchGoods: '/bbb/goodsInfo/searchGoods', //商品搜索列表-cl
    bbbH5GoodsQa: '/bbb/goodsQa', //新增商品咨询-cl
    bbbGoodsQa: '/bbb/goodsQa', //商品咨询列表-cl
    bbbHomeFloorOrAdvert: '/bbb/home/floorOrAdvert', //楼层与广告图-cl
    bbbHomeFloorMenuGoodsQuery: '/bbb/home/floorMenuGoodsQuery', //楼层菜单商品查询-cl
    bbbShopList: '/bbb/shopList', //2Bpc店铺搜索-cl
    bbbShopHome: '/bbb/shopHome/', //2Bpc端店铺首页-cl
    bbbShopHomeId: '/bbb/shopHome/{shopId}', //2Bpc端店铺首页-cl
    bbbShopHomeFloorGoods: '/bbb/shopHome/floorGoods', //2Bpc店铺楼层商品-cl
    bbbShopHomeFloorGoodsId: '/bbb/shopHome/floorGoods/{id}', //2Bpc店铺楼层商品-cl
    bbbGoodsInfoPageShopNavigationGoods: '/bbb/goodsInfo/pageShopNavigationGoods', //店铺自定义分类下面的商品列表-cl
    creditState: '/bbb/userCenter/creditLine/creditState', //店铺自定义分类下面的商品列表-cl
    bbbUserCenterFavoriteShop: '/bbb/userCenter/favoriteShop', //收藏店铺-cl
    bbbUserCenterFavoriteShopDeleteBatch: '/bbb/userCenter/favoriteShop/deleteBatch', //移除店铺收藏-cl
    bbbUserCenterFavoriteGoods: '/bbb/userCenter/favoriteGoods', //商品收藏添加-cl
    bbbUserCenterFavoriteGoodsDeleteBatch: '/bbb/userCenter/favoriteGoods/deleteBatch', //商品收藏移除-cl
    bbbHomeShopSearch: '/bbb/home/shopSearch', //首页店铺搜索-cl
    bbbHomeArticleLinks: '/bbb/home/articleLinks', //首页底部文章和链接列表-cl
    captcha: '/oauth/captcha', //首页底部文章和链接列表-cl
    '/bbb/addUserDemand': '/bbb/addUserDemand',
    resou: '/bbb/home/hotKeyWordList', //首页底部文章和链接列表-cl
    bbbHomeVideo: '/bbb/home/video',
    homefloor: '/bbb/home/floor',
    settleGoodsTotalPrice: '/bbb/settleGoodsTotalPrice',
    bbbWelfareBannerList: '/bbb/welfare/bannerList',
    sanjifenlei: '/bbb/goodsCategory/listCategory',
    getcatPath: '/bbb/goodsCategory/listCateTier',
    allBrand: '/bbb/goodsBrand/listBrand',
    listRelationCategory: '/bbb/goodsCategory/listRelationCategory/{bizType}',
    listCateExtend: '/bbb/goodsCategory/listCateExtend/{cateId}',
    roomboxTemp: '/bbb/roomboxTrade/listTemplate',
    roomboxGoods: '/bbb/roomboxTrade/roomboxDetail',
    roomboxOrderSubmit: '/bbb/roomboxTrade/saveRoomboxTrade',
    bbbWelfareFloorOrAdvert: '/bbb/welfare/floorOrAdvert',
    bbbWelfareVideo: '/bbb/hly/video',
    bbbHlyBannerList: '/bbb/hly/bannerList',
    bbbHlyAdvertList: '/bbb/hly/advertList',
    groupInfo: '/bbb/pc/group/info',
    bbbUserCenterHelpHelpList: '/bbb/help/helpList', //
    bbbUserCenterHelpArticleList: '/bbb/help/articleList',
    searchRecommend: '/bbb/goodsInfo/search/recommend',
    articleSearch: '/bbb/help/search',
    bbbUserCenterHelpDetails: '/bbb/help/details/{id}',
    sysDict: '/bbb/sysDict/listItem',
    getemailbangding: '/pc/bbbAuth/getEmailCode',
    changgouList: '/bbb/userCenter/userFrequent/pageList',
    changgouDel: '/bbb/userCenter/userFrequent/deleteBatch',
    changgouDelGid: '/bbb/userCenter/userFrequent/deleteBatchByGoodsId',
    changGOuAdd: '/bbb/userCenter/userFrequent/saveByGoods',
    roomBoxDetail: '/bbb/roomboxTrade/roomboxList',
    subscribeEmail: '/pc/bbb/usersubscription/subscription',
    bbbUserCenterGetUserInfo: '/bbb/userCenter/getUserInfo',
    getAddressList: '/bbb/pc/region/toCounty',
    bbbUserCenterManagerBindEmail: '/bbb/userCenter/manager/bindEmail',
    bbbUserCenterManagerBindPhone: '/bbb/userCenter/manager/bindPhone',
    bbbUserCenterManagerCheckPassword: '/bbb/userCenter/manager/checkPassword',
    bbbUserCenterManagerEditorPassword: '/bbb/userCenter/manager/editorPassword',
    bbbUserCenterManagerEditorPayPassword: '/bbb/userCenter/manager/editorPayPassword',
    bbbUserCenterManagerEditorUserInfo: '/bbb/userCenter/manager/editorUserInfo',
    bbbUserCenterManagerEditorUserName: '/bbb/userCenter/manager/editorUserName',
    bbbUserCenterManagerGetEditorUserInfo: '/bbb/userCenter/manager/getEditorUserInfo',
    bbbUserCenterUserCardList: '/bbb/userCenter/userCardList',
    bbbmarketMerchantCardUsers: '/bbb/userCenter/coupons/pageList',
    bbbUserCenterStockAddressAdd: '/bbb/pc/userCenter/stockAddress/addStockAddress/{bizType}',
    bbbUserCenterStockAddressInvoiceAddressList: '/bbb/pc/userCenter/stockAddress/invoiceAddressList',
    bbbUserCenterStockAddressList: '/bbb/pc/userCenter/stockAddress/pageStockAddress/{bizType}',
    bbbUserCenterStockAddressDelAll: '/bbb/pc/userCenter/stockAddress/deleteBatch',
    bbbUserCenterStockAddressListEdit: '/bbb/pc/userCenter/stockAddress/updateStockAddress',
    bbbUserCenterStockAddressListEditId: '/bbb/pc/userCenter/stockAddress/updateStockAddress/{id}',
    bbbgetCategoryForBrandId: '/bbb/goodsCategory/getCategoryForBrandId',
    list2thLevelCate: '/bbb/goodsCategory/list2thLevelCate',
    bbbUserCenterStockAddressListRemove: '/bbb/pc/userCenter/stockAddress/deleteAddress',
    deliveryAmount: '/bbb/userCenter/deliveryAmount',
    bbbUserCenterStockAddressListRemoveId: '/bbb/pc/userCenter/stockAddress/deleteAddress/{id}',
    bbbUserCenterGetDefault: '/bbb/pc/userCenter/stockAddress/getDefault',
    bbbUserCenterSetDefault: '/bbb/pc/userCenter/stockAddress/setDefault',
    bbbUserCenterUserType: '/bbb/userCenter/userType',
    bbbUserCenterIntegralLog: '/bbb/userCenter/integralLog',
    bbbUserCenterIntegral: '/bbb/userCenter/integral',
    bbbUserCenterMarketMerchantCardUsers: '/bbb/marketMerchantCardUsers',
    bbbsignInIntegralLog: '/bbb/userCenter/signInIntegralLog',
    bbbsignInIntegralLogState: '/bbb/userCenter/signInIntegralLogState',
    phoneCheck: '/pc/bbbAuth/phoneCheck/{phone}',

    //2Bpc商品咨询管理
    goodsCommentGrade: '/bbb/tradeComment/goodsCommentGrade',
    bbbMerchService: '/bbb/merchService/visits/{shopId}',
    bbbGoodsQaListUserGoodsQa: '/bbb/goodsQa/listUserGoodsQa',
    bbbGoodsQaDeleteBatch: '/bbb/goodsQa/deleteBatch',

    // 购物车
    bbbUserShoppingCar: '/bbb/userCenter/userShoppingCar/updateQuantity/{id}',
    bbbUserShoppingCar2: '/bbb/userCenter/userShoppingCar/getShopCar',
    shopingCarList: '/bbb/userCenterNoAuth/shopingCarList',
    bbbUserShoppingCarAdd: '/bbb/userCenter/userShoppingCar/add',
    bbbUserShoppingCarOrderDelId: '/bbb/userCenter/deleteHistory/{id}',
    bbbUserShoppingCarOrderExport: '/bbb/userCenter/export',
    bbbUserShoppingCarExport: '/bbb/userCenter/userFrequent/export',
    bbbUserShoppingCarHistoryList: '/bbb/userCenter/historyList',
    bbbUserShoppingCarImportOrder: '/bbb/userCenter/userFrequent/saveByOrder',
    bbbUserCenterSetDeleteBatch: '/bbb/h5/userCenter/userShoppingCar/deleteBatch',
    bbbUserSelectStateAll: '/bbb/userCenter/userShoppingCar/selectStateAll',
    bbbUserSelectState: '/bbb/userCenter/userShoppingCar/updateSelect',
    bbbUserShoppingCarCount: '/bbb/userCenter/userShoppingCar/count',
    bbbUserShoppingCarDeleteAll: '/bbb/userCenter/userShoppingCar/deleteBatch',
    userFrequentGoods: '/bbb/userCenter/userFrequent',
    userFrequentGoodsDelete: '/bbb/userCenter/userFrequent',
    userFrequentGoodsAll: '/bbb/userCenter/userFrequent/deleteBatch',
    pcBbbAuthRegister: '/pc/bbbAuth/register',
    pcBbbAuthGetPhoneCheck: '/pc/bbbAuth/getPhoneCheck/{phone}',
    pcBbbAuthForgetByPhone: '/pc/bbbAuth/forgetByPhone',
    cartGoodsInfo: '/bbb/goodsInfo/best',
    pcBbbAuthLogout: '/pc/bbbAuth/logout',

    //企业员会入驻
    bbbUserCenterApplyApply: '/bbb/userCenter/apply/editCorp', //客户入驻信息提交（主动入驻提交）
    bbbUserCenterApplyCorpTypeCertList: '/bbb/userCenter/apply/corpTypeCertList', //企业类型证照列表(2B客户入驻)（企业类型ID）
    bbbUserCenterApplyCorpTypeCertListId: '/bbb/userCenter/apply/corpTypeCertList/{id}', //企业类型证照列表(2B客户入驻)（企业类型ID）
    corpInfo: '/bbb/userCenter/apply/detail/{type}',
    bbbUserCenterApplyCorpTypeList: '/bbb/userCenter/apply/corpTypeList', //企业类型选择列表(2B客户入驻)
    bbbUserCenterApplyDetail: '/bbb/userCenter/apply/detail/10', //客户入驻信息查询
    bbbserCenterApplyFromApply: '/bbb/userCenter/apply/fromApply', //客户入驻信息提交（商家分享邀请）
    bbbUserCenterApplyApplyRecord: '/bbb/userCenter/apply/applyLog/{type}', //我的认证记录
    loginout: '/auth/logout',
    orderCount: '/bbb/userCenter/tradeStateCount',
    // 预存款
    getDeposit: '/bbb/userCenter/userPreDeposit/getCurrentPreDeposit',
    DepositPageList: '/bbb/userCenter/userPreDeposit/preDepositOrder/pageList',
    DepositPay: '/bbb/userCenter/tradePay/pc/preDeposit/doPay',
    DepositLogs: '/bbb/userCenter/userPreDeposit/preDepositOrder/down',

    // 支付
    preDepositOrderLog: '/bbb/userCenter/userPreDeposit/preDepositOrder/pageList',
    yckDetail: '/bbb/userCenter/userPreDeposit/preDepositOrder/detail/{orderId}',
    preDepositOrder: '/bbb/userCenter/userPreDeposit/preDepositOrder/charge',
    bbbUserCenterDoPay: '/bbb/userCenter/tradePay/pc/payQrCode',
    shouxinPay: '/bbb/userCenter/tradePay/pc/credit/doPay',
    getUserType: '/bbb/userCenter/listPayType',
    bbbUserQrCodeImage: '/bbb/pc/userCenter/payImg',
    erweimaDetail: '/bbb/goodsInfo/code',
    bbbUserCenterIsPay: '/bbb/pc/userCenter/isFinishedPay',
    bbbUserCenterIsPayId: '/bbb/userCenter/tradePay/pc/getPayResult/{id}', // 支付(返回支付二维码请求地址)
    bbbUserCenterOrderSubmit: '/bbb/userCenter/orderSubmit', // 支付(返回支付二维码请求地址)
    CashDeposit: '/bbb/pc/CashDeposit/list', // 保证金列表
    cashDepositsettings: '/bbb/pc/settings/cashDeposit', // 保证金列表

    // 订单管理
    bbbUserCenterOrderList: '/bbb/userCenter/orderList', // 订单列表
    bbbUserCenterSettlement: '/bbb/userCenter/settlement', // 去结算 POST
    roomboxDetailSettlement: '/bbb/roomboxTrade/roomboxDetailSettlement', // 去结算 POST
    quotePriceOrder: '/bbb/userCenter/quotePriceOrder/detail/{id}', // 去结算 POST
    quotePriceOrderexportExcel: '/bbb/userCenter/quotePriceOrder/exportExcel/{id}', // 去结算 POST
    bbbUserCenterOrderCancel: '/bbb/userCenter/orderCancel', // 取消订单
    bbbUserCenterOrderDetail: '/bbb/userCenter/orderDetail', // 订单详情
    orderForPay: '/bbb/userCenter/orderForPay', // 订单详情
    bbbUserCenterLatelyTrade: '/bbb/userCenter/latelyTrade', // 近期订单
    bbbNewTrade: '/bbb/newTrade', //最新订单
    bbbmyCard: '/bbb/useCard', //订单页面我的优惠卷
    bbbUserCenterOfflineDetail: '/bbb/userCenter/offlineDetail',
    bbbUserCenterOfflinePay: '/bbb/userCenter/tradePay/pc/offline/doPay',
    getCategoryNavigationVO: '/bbb/goodsCategory/getCategoryNavigationVO',
    orderDel: '/bbb/userCenter/orderDelete',
    bbbUserCenterCheckStockBeforePay: '/bbb/userCenter/tradePay/checkStockBeforePay',

    //私域店铺管理
    bbbUserCenterPrivateShop: '/bbb/userCenter/privateShop', //我绑定的私域店铺
    bbbUserCenterGetUserType: '/bbb/userCenter/apply/getUserType', //是否是企业客户
    bbbUserCenterJionPrivateShop: '/bbb/userCenter/apply/jionPrivateShop', //企业客户通过邀请码加人私域店铺
    bbbUserCenterJionPrivateShopDeleteBatch: '/bbb/userCenter/privateShop/deleteBatch', //批量删除私域店铺
    bbbUserCenterJionPrivateShopPageLogData: '/bbb/userCenter/privateShop/pageLogData', //私域店铺审核记录
    getwuliu: '/bbb/pc/stockKdniao/listLogistics',
    //交易售后表管理
    bbbUserCenterTradeRights: '/bbb/userCenter/tradeRights/pageList', //交易售后表列表
    bbbUserCenterTradeRightsId: '/bbb/userCenter/tradeRights/detail/{id}', //交易售后表列表
    bbbUserCenterTradeRightsAddAddress: '/bbb/userCenter/tradeRights/addAddress', //确认收货
    bbbUserCenterTradeRightsAddAddress2: '/bbb/userCenter/tradeRights/confirmReceipt',
    bbbUserCenterTradeRightsApply: '/bbb/userCenter/tradeRights/apply', //申请售后
    bbbUserCenterOrderCommentAdditional: '/bbb/tradeComment/orderCommentAdditional', // 追加评论
    bbbUserCenterOrderCommentPage: '/bbb/tradeComment/orderCommentPage', // 订单商品评论列表
    bbbUserCenterMyOrderCommentPage: '/bbb/userCenter/tradeComment/myOrderCommentPage', // 我的评价列表
    bbbUserCenterAnonymous: '/bbb/tradeComment/anonymous', // POST 匿名
    bbbTradeCommentOrderComment: '/bbb/tradeComment/orderComment', //订单商品评论
    bbbTradeCommentDeleteComment: '/bbb/tradeComment/deleteComment', // POST 删除评论

    //订单投诉管理管理
    bbbTradeComplaint: '/bbb/tradeComplaint', //订单投诉管理列表
    bbbTradeComplaintId: '/bbb/tradeComplaint/{item}', //订单投诉管理列表
    bbbTradeComplaintCancelComplaint: '/bbb/tradeComplaint/cancelComplaint', //撤销订单投诉管理

    //发票信息管理
    bbbTradeInvoicePageList: '/bbb/userCenter/invoiceAddress/pageList', //发票地址分页查询
    bbbTradeInvoiceList: '/bbb/userCenter/invoice/pageList', //发票信息列表
    bbbTradeInvoiceEdit: '/bbb/pc/userCenter/invoice/edit', //修改发票信息
    bbbTradeInvoiceEditId: '/bbb/pc/userCenter/invoice/edit/{id}', //修改发票信息
    bbbTradeInvoiceIsDefault: '/bbb/pc/userCenter/invoice/setDefault', //默认发票设置
    bbbTradeInvoiceIsDefaultId: '/bbb/pc/userCenter/invoice/setDefault/{id}', //默认发票设置
    bbbTradeInvoiceSave: '/bbb/pc/userCenter/invoice/save', //新增发票信息
    bbbTradeInvoice: '/bbb/pc/userCenter/invoice', //删除发票信息
    bbbTradeInvoiceId: '/bbb/pc/userCenter/invoice/{id}', //删除发票信息
    bbbgetclickBilling: '/bbb/pc/userCenter/tradeInvoice/clickBilling', //申请开票，默认模板
    bbbUpdateByIsDefaultList: '/bbb/pc/userCenter/tradeInvoice/submitInvoiceApply', // 提交申请开票

    //发票寄送地址
    bbbTradeInvoiceAddressSave: '/bbb/userCenter/invoiceAddress/save', //新增寄送地址信息
    getDefaultInvoiceAddressList: '/bbb/userCenter/invoiceAddress/getDefault', //新增寄送地址信息
    bbbTradeInvoiceAddressList: '/bbb/userCenter/invoiceAddress/list', //寄送地址列表
    bbbTradeInvoiceAddressEdit: '/bbb/userCenter/invoiceAddress/edit', //修改寄送地址信息
    bbbTradeInvoiceAddressEditId: '/bbb/userCenter/invoiceAddress/edit/{id}', //修改寄送地址信息
    bbbTradeInvoiceAddressIsDefault: '/bbb/userCenter/invoiceAddress/isDefault', //默认发票地址设置
    bbbTradeInvoiceAddressIsDefaultId: '/bbb/userCenter/invoiceAddress/setDefault/{id}', //默认发票地址设置
    bbbTradeInvoiceAddress: '/bbb/userCenter/invoiceAddress', //删除寄送地址信息
    bbbTradeInvoiceAddressId: '/bbb/userCenter/invoiceAddress/{id}', //删除寄送地址信息

    //交易订单管理
    bbbUserCenterOrderConfirmReceipt: '/bbb/userCenter/orderConfirmReceipt', //订单确认收货

    //活动展示接口
    discountAll: '/bbb/marketActivity/discount', //满折商品全部
    discountFive: '/bbb/marketActivity/discount/viewFour', //满折商品5个
    groupbuyAll: '/bbb/marketActivity/groupbuyList', //团购商品全部
    groupbuyFive: '/bbb/marketActivity/groupbuy/viewFour', //团购商品5个
    marketActivityAll: '/bbb/marketActivity', //满减商品全部
    marketActivityFive: '/bbb/marketActivity/viewFour', //满减商品5个
    giftListAll: '/bbb/marketActivity/giftList', //满赠商品全部
    giftListFive: '/bbb/marketActivity/gift/viewFour', //满赠商品5个
    couponsCars: '/bbb/marketActivity/activityCard', //商家店铺优惠卷
    receivecouponsCars: '/bbb/userCenter/marketActivity/activityCard', //用户领取优惠卷
    bbbjurisdiction: '/bbb/activity/jurisdiction', //活动是否展示
    platFormdetail: '/bbb/marketActivity/activity', //平台活动详情
    platactivityList: '/bbb/marketActivity/activityList', //平台活动列表
    getMerchantArticle: '/bbb/shopHome/getMerchantArticle/{shopId}',
    getShopArticleDetail: '/bbb/shopHome/getMerchantArticleDetail/{articleId}',

    //微信扫码登录
    getQrCode: '/wx/getQrcode', //获取二维码 带参数sceneId 随机9位数字 做呼吸检测用
    wxQrState: '/wx/loginState', //微信扫码状态检测
    wxBindPhone: '/wx/bindOutPhone', //微信扫码后绑定手机号

    //手机号登录

    //报价单
    baojiaList: '/bbb/userCenter/quotePriceOrder/pageList',
    toQuodePriceEdit: '/bbb/userCenter/quotePriceOrder/toQuodePriceEdit',
    baojiaSubmit: '/bbb/userCenter/quotePriceOrder/save',
    baojiaDetailId: '/bbb/userCenter/quotePriceOrder/detail/{id}',
    baojiaSave: '/bbb/userCenter/quotePriceOrder/save',
    baojiaSaveOrder: '/bbb/userCenter/quotePriceOrder/transferOrder/{id}',

    getApplyByCreditCode: '/bbb/userCenter/apply/getApplyByCreditCode',
    chawuliu: '/bbb/pc/stockKdniao/queryExpress/{id}',

    offlineTrade: '/bbb/userCenter/offlineTrade',
    getCollectAccount: '/bbb/userCenter/tradePay/pc/getCollectAccount',

    shouxinDeatilId: '/bbb/userCenter/creditApply/applyLog/{id}',
    exportshouxinLog: '/bbb/userCenter/creditLine/downListUseLog',
    exportShouxinBill: '/bbb/userCenter/creditLine/downListBillItem', //导出
    shouxinBillDetailId: '/bbb/userCenter/creditLine/detailBill/{id}', //详情
    huankuan: '/bbb/userCenter/tradePay/pc/credit/refundOffline', //详情
    bzjhuankuan: '/bbb/pc/CashDeposit/marginSubscription', //详情
    listBillTongji: '/bbb/userCenter/creditLine/totalData', //详情
    shouxinBillList: '/bbb/userCenter/creditLine/listBill', //列表
    shouxinYuejieDetail: '/bbb/userCenter/creditLine/listBillItem/{id}', //月结账单明细
    shouxinJiaoyiLogList: '/bbb/userCenter/creditLine/listUseLog', //授信交易记录
    getShouxinInfo: '/bbb/userCenter/creditLine/myCredit', //授信额度
    shouxinApplyList: '/bbb/userCenter/creditApply/pageList',
    shouxinApply: '/bbb/userCenter/creditApply/save',
    wxGetuserInfo: '/wx/open/getUserInfo',
    phoneLogin: '/pc/bbbAuth/login',
    openbindPhone: '/wx/open/bindPhone',
    qqbindPhone: '/qq/bindPhone',
    huobi: '/bbb/pc/settings/currency', //自定义配置
    editComtentId: '/bbb/tradeComment/edit/{id}',
    getComtentId: '/bbb/userCenter/tradeComment/{id}',
    homeArticle: '/bbb/home/getArticle', //轮播图-cl
    homeHot: '/bbb/home/getHotSellingList',
    homeFanan: '/bbb/home/getRoombox',
    homeCaigou: '/bbb/home/getSiteHotelPurchaseSetting',
    homeLeftZq: '/bbb/home/getSiteLeftRecommend',
    homeRignhtZq: '/bbb/home/getSiteRightRecommend',
    homeFloor: '/bbb/home/floorMenuGoodsQuery',
    homeLouceng: '/bbb/home/listSiteRecommend',
    GhomeHot: '/bbbGroup/home/getHotSellingList',
    GhomeFanan: '/bbbGroup/home/getRoombox',
    GhomeCaigou: '/bbbGroup/home/getSiteHotelPurchaseSetting',
    GhomeLeftZq: '/bbbGroup/home/getSiteLeftRecommend',
    GhomeRignhtZq: '/bbbGroup/home/getSiteRightRecommend',
    GhomeLouceng: '/bbbGroup/home/floorMenuGoodsQuery',
    GhomeArticle: '/bbbGroup/home/getArticle',
    Ghomefloor: '/bbbGroup/home/floor', //首页视频-cl
    GbbbGoodsCategory: '/bbbGroup/home', //2Bpc端首页分类菜单信息-cl

    // #region 统计图表
    statisticsOrder:'/bbb/userCenter/statistics/queryStatisticsOrder', // 订单饼图
    statisticsTradeByBrand:'/bbb/userCenter/statistics/queryStatisticsTradeByBrand', // 品牌饼图
    statisticsTradeByCategory:'/bbb/userCenter/statistics/queryStatisticsTradeByCategory', // 品类饼图
    statisticsTradeByGoodsNo:'/bbb/userCenter/statistics/queryStatisticsTradeByGoodsNo', // 商品饼图

    statisticsZhexianTrade:'/bbb/userCenter/statistics/queryStatisticsZhexianTrade', // 订单折线图
    statisticsZhexianCloum:'/bbb/userCenter/statistics/queryStatisticsZhexianCloum', // 其他折线图
    // #region

    addTrackIndo:'/bbb/addtrackIndo',
}
// i18n-ignore>
